/**
 * Global constants and configuration
 */

/**
 * Enable debug mode to show development controls:
 * - Camera height adjustment ([ and ] keys)
 * - Player speed adjustment (- and = keys)
 * - GUI panels for fine-tuning
 */
export const DEBUG = false;
export const INTERACTION_RANGE = 40;
